import React from 'react';
import PropTypes from 'prop-types';

function Checkbox(props) {
  const id = props.label.toLowerCase().replace(/\s/g, '-');

  return (
    <div className="form__group">
      <div className="checkbox-wrapper">
        <input id={id} type="checkbox" {...props} />
        <span className="checkbox-wrapper__icon"></span>
      </div>
      <label htmlFor={id} dangerouslySetInnerHTML={{__html: props.label}}></label>
    </div>
  );
}

Checkbox.propTypes = {
  label: PropTypes.string,
};

export default Checkbox;
